<template>
  <div class="Index">

    <div class="header">
      <img @click="routers('/CarmichaelMake')" src="../../assets/Index/make.png" alt="">
      <img @click="routers('/LookupReport')" src="../../assets/Index/report.png" alt="">
    </div>

    <ul class="main">
      <li @click="link('/List',3)" >
        <img src="../../assets/Index/commodity1.png" alt="">
        <p>锦医未</p>
      </li>
<!--      IntegratedGender-->
      <li @click="link('/List',2)" >
        <img src="../../assets/Index/commodity2.png" alt="">
        <p>整合式筛查</p>
      </li>
      <li @click="link('/List',0)" >
        <img src="../../assets/Index/commodity3.png" alt="">
        <p>体检套餐</p>
      </li>
      <li @click="link('/List',1)" >
        <img src="../../assets/Index/commodity4.png" alt="">
        <p>胃肠道筛查</p>
      </li>
    </ul>


    <div class="footer">
<!--      <img src="../../assets/Index/Banner.png" alt="">-->
      <van-swipe >
        <van-swipe-item v-for="item in swiperList" :key="item.id">
<!--          v-lazy="item.bannerUrl"-->
          <img :src="item.bannerUrl" @click="clickBanner(item)" />
        </van-swipe-item>
      </van-swipe>

      <div class="divider">
        <div class="divider-box">
          <van-divider>御锦健康</van-divider>
        </div>
        <p class="divider-text">助人为乐的践行者</p>
      </div>

    </div>


  </div>
</template>

<script>

export default {
  name: "Index",
  data() {
    return{
      swiperList: []
    }
  },
  created() {

    // 轮播图
    this.getSwipe();

  },
  mounted() {

  },
  methods: {
    clickBanner(y) {

      if(y.isExternalUrl) {
        window.location.href= y.jumpUrl;
      }else {
        if(y.jumpUrl == "taxi") {
          this.$router.push({
            path: "/TestKitSpread",
            query: {
              state: y.jumpUrl
            }
          })
        }else if(y.jumpUrl == "normal") {
          this.$router.push({
            path: "/TestKitSpread",
            query: {
              state: y.jumpUrl
            }
          })
        }else {
          this.$router.push({
            path: y.jumpUrl
          })
        }

      }

    },
    getSwipe() {
      this.$get("activity/banner")
        .then(res => {
          if(res) {
            console.log(res.data)

            this.swiperList= res.data;
          }
        })
    },
    // 预约 报告
    routers(e) {
      this.$router.push({
        path: e
      })
    },
    // 御锦精选
    link(e,y) {
      this.$router.push({
        path: e,
        query: {
          id: y
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
    @import "../../style/Nav/Index";
</style>
